import { FC, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getOsByEvento } from '../../../Service/os'
import { BD } from '../styles'

/**
 * Resolve a OS 1:1 de um evento (usado pelo card na tela do evento) e
 * redireciona para /interno/os/:id.
 */
export const OsResolver: FC = () => {
  const { eventoId } = useParams<{ eventoId: string }>()
  const navigate = useNavigate()
  const [erro, setErro] = useState(false)

  useEffect(() => {
    let ativo = true
    getOsByEvento(Number(eventoId))
      .then((res) => {
        if (ativo) navigate(`/interno/os/${res.data.data.id}`, { replace: true })
      })
      .catch(() => ativo && setErro(true))
    return () => {
      ativo = false
    }
  }, [eventoId, navigate])

  return (
    <div style={{ padding: 40, color: BD.grayText }}>
      {erro ? 'Nenhuma OS encontrada para este evento.' : 'Abrindo Ordem de Serviço…'}
    </div>
  )
}

export default OsResolver
